var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-title-wrap"},[_c('div',{staticClass:"icon"},[(_vm.icon === 'RegisterIcon')?_c('RegisterIcon',{staticClass:"svg-icon svg-icon-register"}):_vm._e()],1),_c('div',{staticClass:"text"},[_c('span',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))]),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }